import type { ButtonHTMLAttributes, TouchEvent } from 'react';

const ControlButton = ({
  style,
  onClick,
  ...props
}: ButtonHTMLAttributes<HTMLButtonElement>) => {
  const handleTouchEnd = (e: TouchEvent<HTMLButtonElement>) => {
    e.preventDefault();
    e.stopPropagation();
    // Trigger click handler directly for immediate mobile response
    if (onClick) {
      onClick(e as unknown as React.MouseEvent<HTMLButtonElement>);
    }
  };

  return (
    <button
      onClick={onClick}
      onTouchEnd={handleTouchEnd}
      style={{
        border: 'none',
        color: 'var(--gold)',
        background: 'transparent',
        padding: '0.5rem',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
        transition: 'all 0.2s ease',
        ...style,
      }}
      {...props}
    />
  );
};

export default ControlButton;
